import { useContext } from "react";
import { TokenContext } from "../providers/token-provider";

export const useToken = () => {
  const db = useContext(TokenContext);
  return db;
};
